import styled from 'styled-components';

export const TermsAndConditionsContainer = styled.div`
    padding: 16px;
`;
